import { combineReducers } from "redux";
import { reducer as toastr } from "react-redux-toastr";
import api_auth from "./api_auth";
import api_subject from "./api_subject";
import api_teacher from "./api_teacher";
import class_request_form from "./class_request_form";
import redirect from "./redirect";
import loading from "./loading";
import errors from "./errors";
import google_auth from "./google_auth";

const reducers = combineReducers({
  loading,
  errors,
  toastr,
  redirect,
  class_request_form,
  api_auth,
  api_subject,
  api_teacher,
  google_auth,
});

export default reducers;
